import React, { useState } from 'react';
import { Modal, SearchableSelect } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function AddBOMModal({ onClose, onSaved, initialProductId }) {
  const { data: products } = useFetch('/api/products');
  const { data: materials } = useFetch('/api/raw-materials');
  const [productId, setProductId] = useState(initialProductId ? String(initialProductId) : '');
  const [rows, setRows] = useState([{ materialId: '', qtyPerUnit: '1' }]);
  const [saving, setSaving] = useState(false);

  const productOptions = (products || []).map(p => ({ value: p.id, label: `${p.sku} — ${p.name}` }));
  const materialOptions = (materials || []).map(m => ({ value: m.id, label: `${m.name} (${m.unit_of_measure})` }));

  const addRow = () => setRows(r => [...r, { materialId: '', qtyPerUnit: '1' }]);
  const removeRow = (idx) => setRows(r => r.filter((_, j) => j !== idx));
  const setRow = (idx, k, v) => setRows(r => r.map((row, j) => j === idx ? { ...row, [k]: v } : row));

  const save = async (e) => {
    e.preventDefault();
    if (!productId) { alert('Please select a product'); return; }
    const valid = rows.filter(r => r.materialId && r.qtyPerUnit);
    if (!valid.length) { alert('Add at least one part'); return; }
    setSaving(true);
    try {
      await api.post('/api/bom', {
        productId: parseInt(productId),
        rawMaterials: valid.map(r => ({
          materialId: parseInt(r.materialId),
          qtyPerUnit: parseFloat(r.qtyPerUnit),
          preferredVendorId: null,
        }))
      });
      onSaved('BOM created successfully'); onClose();
    } catch(err) { alert(errMsg(err)); }
    finally { setSaving(false); }
  };

  return (
    <Modal title="New Bill of Materials" onClose={onClose} wide
      footer={<><button className="btn" onClick={onClose}>Cancel</button><button className="btn btn-primary" form="add-bom-form" type="submit">{saving?'Saving…':'Create BOM'}</button></>}>
      <form id="add-bom-form" onSubmit={save}>
        <div className="form-group">
          <label>Finished good (product) *</label>
          <SearchableSelect value={productId} onChange={setProductId} options={productOptions} placeholder="— Search or select product —" />
        </div>
        <div style={{ fontWeight:500, fontSize:13, marginBottom:8, marginTop:16 }}>Parts</div>
        {rows.map((row, idx) => (
          <div key={idx} style={{ display:'grid', gridTemplateColumns:'3fr 1fr auto', gap:8, marginBottom:8, alignItems:'end' }}>
            <div className="form-group" style={{ margin:0 }}>
              {idx===0 && <label style={{ fontSize:11 }}>Part</label>}
              <SearchableSelect
                value={row.materialId}
                onChange={v => setRow(idx, 'materialId', v)}
                options={materialOptions}
                placeholder="— Search parts —"
              />
            </div>
            <div className="form-group" style={{ margin:0 }}>
              {idx===0 && <label style={{ fontSize:11 }}>Qty per unit</label>}
              <input type="number" step="0.0001" min="0" value={row.qtyPerUnit} onChange={e=>setRow(idx,'qtyPerUnit',e.target.value)} />
            </div>
            <button type="button" className="btn btn-sm btn-danger" style={{ marginTop: idx===0?18:0 }} onClick={()=>removeRow(idx)}>
              <i className="ti ti-x" />
            </button>
          </div>
        ))}
        <button type="button" className="btn btn-sm" onClick={addRow} style={{ marginTop:4 }}>
          <i className="ti ti-plus" /> Add part
        </button>
      </form>
    </Modal>
  );
}
